export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";